import { useState, createRef } from "react";
import { useRouter } from "next/router";
import { post } from "services/actions";
import { detalheImovelForm } from "validations";
import { toast } from 'react-toastify'
import Markdown from "markdown-to-jsx";
import dynamic from "next/dynamic";
import ReCAPTCHA from 'react-google-recaptcha'
import styles from "./proprietyDescription.module.css";


const InputMasked = dynamic(() => import('react-input-mask'), {
  ssr: false
})

export default function ProprietyDescription({ data }) {
  const [nome, setNome] = useState("");
  const [isValidNome, setIsValidNome] = useState(true);
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [telefone, setTelefone] = useState("");
  const [isValidTelefone, setIsValidTelefone] = useState(true);
  const [selected, setSelected] = useState("");
  const [isValidSelected, setIsValidSelected] = useState(true);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [show, setShow] = useState(false);


  const recaptchaRef = createRef();

  const router = useRouter();

  const query = router.query

  const pagina = router.asPath;

  const options = [
    {
      label: "Quando pretende comprar este imóvel ?",
      value: "quando",
    },
    {
      label: "Este ano",
      value: "este ano",
    },
    {
      label: "Ano que vem",
      value: "ano que vem",
    },
    {
      label: "Dois anos",
      value: "dois anos",
    },
    {
      label: "Mais de dois anos",
      value: "mais de dois anos",
    },
  ];

  async function onReCAPTCHAChange(captchaCode) {
    if (!captchaCode) {
      return
    }
    
    recaptchaRef.current.reset()
  }


  async function handleSubimit(e) {
    e.preventDefault();

    const rdOptions = {
      event_type: "CONVERSION",
      event_family: "CDP",
      payload: {
        conversion_identifier: pagina.split('/')[2],
        name: nome,
        email,
        personal_phone: telefone,
        traffic_source: query.utm_source,
        traffic_medium: query.utm_medium,
        traffic_campaign: query.utm_campaign,
        legal_bases: [
          {
            category: "communications",
            type: "consent",
            status: "granted"
          }
        ]
      }
    }

    await recaptchaRef.current.executeAsync()
    setDisabled(true)
    setLoading(true)
        
    const validateNome = await detalheImovelForm.nome.isValid({ nome });
    const validateEmail = await detalheImovelForm.email.isValid({ email });
    const validateTelefone = await detalheImovelForm.telefone.isValid({
      telefone,
    });
    const validateSelected = await detalheImovelForm.selected.isValid({
      selected,
    });
    
    setIsValidNome(validateNome);
    setIsValidEmail(validateEmail);
    setIsValidTelefone(validateTelefone);
    setIsValidSelected(validateSelected);

    if (validateNome & validateEmail & validateTelefone & validateSelected) {
      try {  
        await post("contatos", {
          nome,
          email,
          telefone,
          pagina: pagina.replace("/", ""),
        });

        await fetch('/api/rdStationConversion', {
          method: 'POST',
          body: JSON.stringify(rdOptions)
        })

        toast.success('Formulário enviado com sucesso!')
        setNome("");
        setEmail("");
        setTelefone("");
        setSelected("");
        setLoading(false)
        setDisabled(false)
      } catch {
        toast.error('Erro ao enviar formulário!')
        setLoading(false)
        setDisabled(false)
      }
    } else {
      setDisabled(false)
      setLoading(false)
    }
  }

  return (
    <section className={styles.container}>
      <div className={`grid-cont ${styles.content}`}>
        <div className={styles.description}>
          <div
            style={{ height: show ? "auto" : "280px" }}
            className={styles.descInner}
          >
            <div className={styles.title}>
              <div className={styles.parallelogramDetail} />
              <span>{data.titulo}</span>
            </div>
            <Markdown>{data?.descricao}</Markdown>
          </div>
          <button onClick={() => setShow(!show)}>
            <img src="/icons/icone-botao.png" alt="Abrir todo o texto" width={12} height={24} />
            <span>{show ? "Esconder o texto" : "Abrir todo o texto"}</span>
          </button>
        </div>
        <div className={`d-flex ${styles.formCont}`}>
          <form id="form" method="post" onSubmit={handleSubimit} className={styles.form}>
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
              onChange={onReCAPTCHAChange}
            />
            <div className={styles.formTitle}>
              <span>Ficou interessado?</span>
              <span>Cadastre-se e receba um contato</span>
            </div>
            <div className={!isValidNome ? styles.spanField : ""}>
              <input
                name="nome"
                placeholder="Nome"
                value={nome}
                onChange={(e) => {
                  setNome(e.target.value)
                  setDisabled(false)
                }}
              />
              <span className={isValidNome ? styles.spanDisplayNone : ""}>
                * Campo obrigatório
              </span>
            </div>
            <div className={styles.emailCell}>
              <div className={!isValidEmail ? styles.spanField : ""}>
                <input
                  name="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                    setDisabled(false)
                  }}
                />
                <span className={isValidEmail ? styles.spanDisplayNone : ""}>
                  * Informe um email válido
                </span>
              </div>
              <div className={!isValidTelefone ? styles.spanField : ""}>
                <InputMasked
                  name="telefone"
                  placeholder="Telefone"
                  value={telefone}
                  onChange={(e) => {
                    setTelefone(e.target.value)
                    setDisabled(false)
                  }}
                  mask="(99) 99999-9999"
                />
                <span className={isValidTelefone ? styles.spanDisplayNone : ""}>
                  * Campo obrigatório
                </span>
              </div>
            </div>
            <div className={!isValidSelected ? styles.spanField : ""}>
              <select
                value={selected}
                onChange={(e) => {
                  setSelected(e.target.value)
                  setDisabled(false)
                }}
              >
                {options.map((option) => {
                  return (
                    <option key={Math.random()} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
              </select>
              <span className={isValidSelected ? styles.spanDisplayNone : ""}>
                * Informe quando pretende comprar
              </span>
            </div>
            <button type="submit" disabled={disabled}>
              {loading &&
                isValidNome &&
                isValidEmail &&
                isValidTelefone &&
                isValidSelected ? (
                <span>. . .</span>
              ) : (
                <span>ENVIAR CADASTRO</span>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
